import type { ReviewDTO } from "@/modules/reviews/domain/contracts";
import type {
  OffsetPageDTO,
  OffsetPageQueryDTO,
} from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { ReviewDTO };

export const reviewsApi = {
  async list(query: OffsetPageQueryDTO): Promise<OffsetPageDTO<ReviewDTO>> {
    const url = new URL(`${config.apiUrl}/reviews`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<OffsetPageDTO<ReviewDTO>>(url.toString());
  },

  async get(id: string): Promise<ReviewDTO> {
    return fetcher.get<ReviewDTO>(`${config.apiUrl}/reviews/${id}`);
  },

  async updateHidden(id: string, hidden: boolean): Promise<ReviewDTO> {
    return fetcher.patch<ReviewDTO>(`${config.apiUrl}/reviews/${id}`, {
      hidden,
    });
  },

  async delete(id: string): Promise<{ id: string }> {
    return fetcher.delete<{ id: string }>(`${config.apiUrl}/reviews/${id}`);
  },
};
